import React from 'react';
import { Col, Row } from 'react-bootstrap';

const SectionTwo = () => {
     return (
          <div className="container my-5 py-2 ">
               <h3 className='text-center pb-4 fw-bolder text-primary'>ABOUT CARS</h3>
               <Row className='align-items-center'>
                    <Col sm={6}>
                         <img className='img-fluid rounded' src="https://www.drivinggeeks.com/wp-content/uploads/2021/04/young-man-choosing-car-in-car-showroom.jpg.webp" alt="" />
                    </Col>
                    <Col sm={6}>
                         <h5 className='fw-bold'>SOME OF OUR WORDS ....</h5>
                         <p>Everyone who has bought a car from this place likes this car, because we never give a bad car to anyone, once you buy a car from here, you will understand how good the car is, people can own the car in this way. You don't drive here, you can rest and relax there, it will feel like you are sleeping in your room, once you get in this car you will not want to go home anymore, don't buy or watch once</p>
                         <button className='btn btn-primary fw-bold p-2 mt-3'>READ MORE 🡲</button>
                    </Col>
               </Row>
          </div>
     );
};

export default SectionTwo;